import FieldSet from '../../FieldSet';

import { CreatedAt } from './CreatedAt';

export class CreatedAtFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [CreatedAt];
  }

  get title() {
    return 'Created at';
  }
}
